import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { BasicInformations } from '../models/basic-informations.model';

@Injectable({
    providedIn: 'root'
})
export class DigitalService {
    private info: Subject<Boolean> = new BehaviorSubject<Boolean>(false);

    get info$() {
        return this.info.asObservable();
    }

    addInfo(bool) {
        this.info.next(bool);
    }

}